import { render } from "./CostosGuardados.vue?vue&type=template&id=7829e920&scoped=true"
import script from "./CostosGuardados.vue?vue&type=script&lang=js"
export * from "./CostosGuardados.vue?vue&type=script&lang=js"

import "./CostosGuardados.vue?vue&type=style&index=0&id=7829e920&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7829e920"

export default script